import React from 'react';
import { isFeatureLive } from '../../lib/caraloom_v2_ia';
import ArchivedFeaturePage from '../../pages/ArchivedFeaturePage';

/**
 * FeatureGate — wraps a route element with the V2 IA feature-flag check.
 *
 * If `isFeatureLive(featureId)` returns true (the feature is in the current
 * `REACT_APP_CARALOOM_TIER`), the wrapped element renders normally. If the
 * feature is gated (archived, or scheduled for a later tier than the
 * current one), the route renders <ArchivedFeaturePage /> instead so the
 * route still exists (preserves prerender + recoverability) but doesn't
 * expose the V3-era surface to V1 visitors.
 *
 * Source-of-truth for the feature taxonomy: /app/frontend/src/lib/caraloom_v2_ia.js
 * Companion lifecycle doc: /app/memory/CARALOOM_V2_ARCHIVE_PLAN.md
 *
 * Usage:
 *   <Route path="/care-library" element={
 *     <FeatureGate featureId="seo.care-library">
 *       <CareLibraryPage />
 *     </FeatureGate>
 *   } />
 */
export const FeatureGate = ({ featureId, children, fallback = null }) => {
  if (isFeatureLive(featureId)) return children;
  return fallback || <ArchivedFeaturePage featureId={featureId} />;
};

export default FeatureGate;
